import React, { useState } from 'react';
import BlankCanvas from './BlankCanvas';
import LinedCanvas from './LinedCanvas';
import FourLinerCanvas from './FourLinerCanvas';
import GridCanvas from './GridCanvas';

// import FourLinerAlphaStencilsCanvas from './FourLinerAlphaStencilsCanvas';
import FourLinerNumberStencilsCanvas from './FourLinerNumberStencilsCanvas';
import GridNumberStencilsCanvas from './GridNumberStencilsCanvas';
import GridTableStencilsCanvas from './GridTableStencilsCanvas';
import NurseryLinesStencilsCanvas from './NurseryLinesStencilsCanvas';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faRuler, faListAlt, faTh, faA, fa1, faTable, faList, faSmile } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import './NotesCanvas.css';
import axios from 'axios';
import { useSelector } from 'react-redux';

const canvasComponents = [
  { icon: faBook, component: BlankCanvas, name: 'Blank Page' },
  { icon: faRuler, component: LinedCanvas, name: 'Lined Page' },
  { icon: faListAlt, component: FourLinerCanvas, name: 'Four Liner Page' },
  { icon: faTh, component: GridCanvas, name: '2x2 Grid', props: { rows: 2, cols: 2 } },
  { icon: faTh, component: GridCanvas, name: '3x3 Grid', props: { rows: 3, cols: 3 } },
  { icon: faTh, component: GridCanvas, name: '4x4 Grid', props: { rows: 4, cols: 4 } },
  { icon: faTh, component: GridCanvas, name: '5x5 Grid', props: { rows: 5, cols: 5 } },
  { icon: faTh, component: GridCanvas, name: '10x10 Grid', props: { rows: 10, cols: 10 } },
  { icon: faList, component: GridCanvas, name: '2x5 Grid', props: { rows: 2, cols: 5 } },
  ];

const HRCanvas = () => {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();

  const [overlayContent, setOverlayContent] = useState(null);

  const handleIconClick = (Component, props = {}) => {
    setOverlayContent(() => <Component {...props} onClose={handleCloseOverlay} />);
  };

  const handleCloseOverlay = () => {
    setOverlayContent(null);
  };

  const handleBackToHome = () => {
    navigate("/touchbook-home")
  };


  return (
    <div className="full-screen-overlay">
      <div className='flex flex-col'>
        <div className='flex justify-center items-center my-4'>
            <p className='text-white bg-lime-800 text-xl font-semibold rounded-lg px-6 py-2 shadow-lg'>
                {authState.user.name}'s Digital Exercise Books
            </p>
        </div>
        <div className="canvas-grid">
            {canvasComponents.map((item, index) => (
                <div 
                key={index} 
                className="icon text-lime-400" 
                onClick={() => handleIconClick(item.component, item.props)}
                >
                <FontAwesomeIcon className="text-lime-400" icon={item.icon} size="200x" />
                <p className='text-lime-400'>{item.name}</p>
                </div>
            ))}
        </div>
        {overlayContent && (
            <div className="overlay">
            {overlayContent}
            </div>
        )}
        <div>
            <button onClick={handleBackToHome}>Close</button>
        </div>
    </div>
   </div>
  );
};

export default HRCanvas;

